import { Alert, AlertTitle } from '@mui/material';

import { Button, StoreOutlinedIcon } from '@occc-app/design-system';

type SetSpecificGoalBannerProps = {
  onActionButtonClick: () => void;
};

export const SetSpecificGoalBanner = ({ onActionButtonClick }: SetSpecificGoalBannerProps) => {
  return (
    <Alert
      severity='info'
      icon={<StoreOutlinedIcon sx={{ fill: 'primary.dark' }} />}
      action={
        <Button color='inherit' size='medium' onClick={onActionButtonClick}>
          Set Goal
        </Button>
      }
      sx={{
        alignItems: 'center',
        p: 2,
        '& .MuiAlert-message': { p: 0 },
        '& .MuiAlert-action': { mr: 0, pt: 0 },
      }}
    >
      <AlertTitle>Set a Site Specific Goal</AlertTitle>
      You can now set a goal specifically for this site
    </Alert>
  );
};
